
import '@/assets/scss/index.scss'
import { commonfunc } from '~/mixin/common'
import mbUtils from '~/scriptData/mb/utils/mbUtils'

export default {
  components: {
  },
  mixins: [commonfunc, mbUtils],
  data () {
    const customValidate = (rule, value, callback) => {
      // this.isDisabled = false

      if (rule.field === 'rfmtAcunInfoEacn') {
        if (this.form.rfmtAcunInfoBankCd === '') {
          callback(new Error('은행을 선택해주세요.'))
          return
        } else if (this.form.rfmtAcunInfoEacn === '') {
          callback(new Error('계좌번호를 입력해 주세요.'))
          return
        }
      } else if (rule.field === 'rfmtAcunInfoDpsrEfnm') {
        if (this.form.certYn === '') {
          callback(new Error('인증이 필요합니다.'))
          return
        } else if (this.form.certYn === 'N') {
          callback(new Error('인증이 실패하였습니다.'))
          return
        }
      }

      callback()
    }
    return {
      outerVisible: false,
      labelPosition: 'top',
      bankList: [],
      // isDisabled: false,
      agrDc: {},
      form: {
        mbMngNo: '',
        lsUpdrId: '',
        rfmtAcunInfoBankCd: '',
        rfmtAcunInfoEacn: '',
        rfmtAcunInfoDpsrEfnm: '',
        certYn: '',
        agrYn: 'N'
      },
      // checked: false,
      rules: {
        rfmtAcunInfoEacn: [
          { validator: customValidate, trigger: 'blur' },
          { required: true, message: '계좌번호를 입력해 주세요', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '숫자만 입력해 주세요.', trigger: 'blur' }
        ],
        rfmtAcunInfoDpsrEfnm: [
          { required: true, message: '예금주를 입력해 주세요', trigger: 'blur' },
          { max: 30, message: '예금주는 30자까지 입력 가능합니다.', trigger: 'blur' },
          { validator: customValidate, trigger: 'blur' }
        ],
        // checked: [
        //   { validator: customValidate, trigger: 'change' }
        // ]
      }
    }
  },
  computed: {
    isDisabled () { // 2024.02.07. 추가.
      if (this.form.agrYn === 'Y' && this.form.certYn === 'Y') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    outerVisible (val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate() // 2024.02.07. 추가.
          }
        })
        this.form.certYn = '' // 2024.02.07. 추가.
        this.selRfmtAcunInfo()
        // this.checked = false
      }
    }
  },
  async mounted () {
    const grpList = ['CD_00406', 'CD_00099']
    this.cmmnCdList = await this.selCmmnCd(grpList) // 공통 코드
    const agrCode = this.cmmnCdFilter(this.cmmnCdList, 'CD_00406', '', '').filter((f) => { return f.cmmnCd === 'B0' })[0]
    this.agrDc = agrCode.cmmnCdDc.split('\n')
    // this.bankList = this.cmmnCdFilter(this.cmmnCdList, 'CD_00099', { scdUserFd: 'MB' }, 'S')
    this.bankList = this.cmmnCdFilter(this.cmmnCdList, 'CD_00099', '', 'S') // 2024.01.10. 마이페이지 환불계좌에 전체 은행 나오도록 수정
  },
  methods: {
    initCert () {
      this.form.certYn = ''
      this.$refs.form.validate()
    },
    selRfmtAcunInfo () {
      this.$AxiosBuilder
        .data(this.form)
        .build()
        .post('/mb/mbc/selRfmtAcunInfo')
        .then((res) => {
          console.log(res)
          if (this.isNotEmpty(res.data.data)) {
            if (this.isNotEmpty(res.data.data.rfmtAcunInfoBankCd)) {
              this.form.rfmtAcunInfoBankCd = res.data.data.rfmtAcunInfoBankCd
              // this.form.certYn = 'Y'
              this.form.agrYn = 'Y' // 2024.02.07. 추가.
            } else {
              // this.form.certYn = 'N'
              this.form.agrYn = 'N' // 2024.02.07. 추가.
            }
            this.form.rfmtAcunInfoDpsrEfnm = res.data.data.rfmtAcunInfoDpsrEfnm
            this.form.rfmtAcunInfoEacn = res.data.data.rfmtAcunInfoEacn
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    },
    cert () {
      this.$refs.form.validate((valid, msg) => {
        console.log(msg)
        if (!valid && !msg.rfmtAcunInfoEacn && msg.rfmtAcunInfoDpsrEfnm && msg.rfmtAcunInfoDpsrEfnm[0].message === '인증이 필요합니다.') {
          if (process.env.VUE_APP_ENV === 'loc') {
            // this.$alert(this.$t('MB.CONFIRMED'), { center: true })
            this.openToast(this.$t('MB.CONFIRMED_ACCOUNT'), { center: true })
            this.form.certYn = 'Y'
            this.form.agrYn = 'N' // 2024.02.07. 추가.
            this.$refs.form.validateField('rfmtAcunInfoDpsrEfnm')
            // this.disbBtn()
          } else {
            const certData = {}
            certData.LGD_BANKCODE = this.form.rfmtAcunInfoBankCd
            certData.LGD_ACCOUNTNO = this.form.rfmtAcunInfoEacn
            certData.LGD_NAME = this.form.rfmtAcunInfoDpsrEfnm
            this.$AxiosBuilder
              .data(certData)
              .build()
              .post('/mb/mbc/certRfmtAcunInfo')
              .then((res) => {
                console.log(res)
                if (this.isNotEmpty(res.data.message)) {
                  if (res.data.message === 'api Succ') {
                    this.openToast(this.$t('MB.CONFIRMED'), { center: true })
                    this.form.certYn = 'Y'
                    this.form.agrYn = 'N' // 2024.02.07. 추가.
                    this.$refs.form.validateField('rfmtAcunInfoDpsrEfnm')
                    // this.disbBtn()
                  } else if (res.data.message === 'api Fail') {
                    this.form.certYn = 'N' // 2024.02.07. 추가.
                    this.$alert(this.$t('MB.NOT_AVAILABLE_ACCOUNT'), { center: true })
                    return false
                  }
                }
              })
              .catch((err) => {
                this.form.certYn = 'N' // 2024.02.07. 추가.
                this.$alert(this.$t('MB.NOT_AVAILABLE_ACCOUNT'), { center: true })
                console.log('error')
                console.log(err)
              })
          }
        } else if (valid && this.form.certYn === 'Y') {
          this.openToast(this.$t('MB.CONFIRMED_ACCOUNT'), { center: true })
          this.form.agrYn = 'N' // 2024.02.07. 추가.
          // this.disbBtn()
        } else {
          return false
        }
      })
    },
    upRfmtAcunInfo (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.agrYn !== 'Y') {
            this.$alert(this.$t('MB.AGREE_PRIVACY_TERMS'))
            return false
          } else {
            this.$AxiosBuilder
              .data(this.form)
              .build()
              .post('/mb/mbc/upRfmtAcunInfo')
              .then((res) => {
                this.$alert(this.$t('MB.SAVE_RETURN_ACCOUNT')).then(() => {
                  this.form.certYn = ''
                  // this.isDisabled = false
                  this.outerVisible = false
                }).catch(() => {})
              })
              .catch((err) => {
                console.log('error')
                console.log(err)
              })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm () {
      this.form.rfmtAcunInfoBankCd = ''
      this.form.rfmtAcunInfoEacn = ''
      this.form.rfmtAcunInfoDpsrEfnm = ''
      this.form.certYn = ''
      this.form.agrYn = 'N'
      console.log(this.form)
    },
    setNumber () {
      this.form.rfmtAcunInfoEacn = this.form.rfmtAcunInfoEacn.replace(/[^0-9]/g, '')
      this.initCert()
    },
    // disbBtn () {
    //   console.log(this.form)
    //   if (this.form.agrYn === 'Y' && this.form.certYn === 'Y') {
    //     this.isDisabled = true
    //   } else {
    //     this.isDisabled = false
    //   }
    // }
  }
}
